import { render } from "./PlanningTaskTree.vue?vue&type=template&id=2c24c490&scoped=true&ts=true"
import script from "./PlanningTaskTree.vue?vue&type=script&lang=ts"
export * from "./PlanningTaskTree.vue?vue&type=script&lang=ts"

import "./PlanningTaskTree.vue?vue&type=style&index=0&id=2c24c490&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c24c490"]])

export default __exports__